<div
    class="shadow-lg matTableContainer !w-full overflow-x-auto"
    [class.resizable-columns]="enableColumnsConfig"
    [class.multiLineHeader]="hasMultiLineHeader"
    *transloco="let translate">
    <div class="tableWrapper" [hidden]="!show || !columnKeyPair">
        <table
               aria-describedby="library table"
               mat-table
               [dataSource]="dataSource"
               [trackBy]="trackByRecordId"
               multiTemplateDataRows
               class="pAdjust"
               [ngClass]="{ '!border-collapse': showRowBorders }">
            <ng-container *ngFor="let columnId of selectedColumns; let i = index; trackBy: trackBySelectedColumnsMethod">
                <ng-container
                              [matColumnDef]="columnId"
                              [sticky]="!noSticky && i < 1"
                              [stickyEnd]="!noSticky && i > selectedColumns.length - 3">
                    <ng-container [ngSwitch]="columnTypePair[columnId]">
                        <ng-container *ngSwitchCase="'text'">
                            <th
                                scope="col"
                                mat-header-cell
                                *matHeaderCellDef
                                class="matTableHeader"
                                [title]="columnKeyPair?.[columnId]?.name">
                                <span
                                      class="columnName"
                                      [class.adjustWidth]="!(!enableColumnEdit || fieldsDisabledForEdit.includes(columnId))">
                                    <material-button
                                                     *ngIf="columnKeyPair?.[columnId]?.icon"
                                                     buttonType="icon"
                                                     [size]="'small'"
                                                     [prefixIcon]="columnKeyPair?.[columnId]?.icon"
                                                     [classList]="['title_icon', columnKeyPair?.[columnId]?.icon]"></material-button>
                                    <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                </span>
                                <material-checkbox
                                                   class="columnToUpdate"
                                                   [(model)]="columnsToUpdate[columnId]"
                                                   [class.displayNone]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"></material-checkbox>
                                <material-button
                                                 buttonType="icon"
                                                 [size]="'small'"
                                                 prefixIcon="edit"
                                                 [classList]="['fontSizeCls']"
                                                 [hidden]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"
                                                 (buttonClicked)="editColumnEvent.emit(columnId)"></material-button>
                                <div class="d-flex">
                                    <ng-container *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                    <ng-container *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                </div>
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                class="matTableCell"
                                [title]="
                                    (element.isDeleted
                                        ? 'This record was deleted'
                                        : !element.inAudit &&
                                          columnKeyPair?.[columnId]?.uiTypeMetadata !== 'TEXTAREA' &&
                                          element?.uiTypeMetadata !== 'TEXTAREA'
                                        ? element[columnId] || '--'
                                        : ''
                                    ) | TruncateHTMLTags
                                "
                                (click)="copyToInboundRequestId(element)">
                                <ng-template
                                             *ngTemplateOutlet="textTemplate; context: { element: element, columnId: columnId }"></ng-template>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'MENU'">
                            <th
                                scope="col"
                                mat-header-cell
                                *matHeaderCellDef
                                class="matTableHeader"
                                [title]="columnKeyPair?.[columnId]?.name">
                                <span
                                      class="columnName"
                                      [class.adjustWidth]="!(!enableColumnEdit || fieldsDisabledForEdit.includes(columnId))">
                                    <material-button
                                                     *ngIf="columnKeyPair?.[columnId]?.icon"
                                                     buttonType="icon"
                                                     [size]="'small'"
                                                     [prefixIcon]="columnKeyPair?.[columnId]?.icon"
                                                     [classList]="['title_icon', columnKeyPair?.[columnId]?.icon]"></material-button>
                                    <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                </span>
                                <material-checkbox
                                                   class="columnToUpdate"
                                                   [(model)]="columnsToUpdate[columnId]"
                                                   [class.displayNone]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"></material-checkbox>
                                <material-button
                                                 buttonType="icon"
                                                 [size]="'small'"
                                                 prefixIcon="edit"
                                                 [classList]="['fontSizeCls']"
                                                 [hidden]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"
                                                 (buttonClicked)="editColumnEvent.emit(columnId)"></material-button>
                                <div class="d-flex">
                                    <ng-container *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                    <ng-container *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                </div>
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                class="matTableCell"
                                [title]="
                                    (element.isDeleted
                                        ? 'This record was deleted'
                                        : !element.inAudit &&
                                          columnKeyPair?.[columnId]?.uiTypeMetadata !== 'TEXTAREA' &&
                                          element?.uiTypeMetadata !== 'TEXTAREA'
                                        ? element[columnId] || '--'
                                        : ''
                                    ) | TruncateHTMLTags
                                "
                                (click)="copyToInboundRequestId(element)">
                                <ng-template
                                             *ngTemplateOutlet="
                                        menuTemplate;
                                        context: {
                                            element: element,
                                            columnId: columnId,
                                            options: columnKeyPair?.[columnId]?.options,
                                            colorCodes: columnKeyPair?.[columnId]?.colorCodes,
                                            column: columnKeyPair?.[columnId]?.id
                                        }
                                    "></ng-template>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'GRID'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                <material-checkbox
                                                   class="columnToUpdate"
                                                   [(model)]="columnsToUpdate[columnId]"
                                                   [class.displayNone]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"></material-checkbox>
                                <material-button
                                                 buttonType="icon"
                                                 [size]="'small'"
                                                 prefixIcon="edit"
                                                 [classList]="['fontSizeCls']"
                                                 [hidden]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"
                                                 (buttonClicked)="editColumnEvent.emit(columnId)"></material-button>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <ng-template
                                             *ngTemplateOutlet="
                                        gridTemplate;
                                        context: {
                                            element: element,
                                            columnId: columnId,
                                            column: columnKeyPair?.[columnId],
                                            showGridIcon: element.showGridIcon
                                        }
                                    "></ng-template>
                            </td>
                            <div class="d-flex">
                                <ng-container *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                <ng-container *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'input'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                <material-checkbox
                                                   class="columnToUpdate"
                                                   [(model)]="columnsToUpdate[columnId]"
                                                   [class.displayNone]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"></material-checkbox>
                                <material-button
                                                 buttonType="icon"
                                                 [size]="'small'"
                                                 prefixIcon="edit"
                                                 [classList]="['fontSizeCls']"
                                                 [hidden]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"
                                                 (buttonClicked)="editColumnEvent.emit(columnId)"></material-button>
                                <div class="d-flex">
                                    <ng-container *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                    <ng-container *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <ng-container [ngSwitch]="cellDataTypes[element.rowIndex][columnId].readOnly">
                                    <ng-container *ngSwitchCase="true">
                                        <span [textContent]="element[columnId]"></span>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <table-input
                                                     [column]="columnKeyPair?.[columnId]"
                                                     [element]="element"
                                                     [columnId]="columnId"
                                                     [cellDataTypes]="cellDataTypes"></table-input>
                                    </ng-container>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'SELECTRECORD'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <ng-container *ngIf="columnKeyPair?.[columnId].showCheckboxInHeader">
                                    <material-checkbox
                                                       [badge]="selectedRecordsCount > 0 ? selectedRecordsCount : null"
                                                       (modelChange)="toggleRecordsSelection($event)"
                                                       [(model)]="selectAllRecords"
                                                       id="columnId"
                                                       [disabled]="
                                            !dataSource ||
                                            (dataSource && !dataSource.data) ||
                                            (dataSource.data && dataSource.data.length === 0)
                                        "></material-checkbox>
                                </ng-container>
                                <ng-container *ngIf="!columnKeyPair?.[columnId].showCheckboxInHeader">
                                    <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                </ng-container>
                                <div class="d-flex">
                                    <ng-container *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                    <ng-container *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <material-checkbox
                                                   class="recordSelectCheckboxContainer"
                                                   [(model)]="element.selected"
                                                   (modelChange)="onRecordSelectionChange(element)"></material-checkbox>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'select'"></ng-container>
                        <ng-container *ngSwitchCase="'group-select'"></ng-container>
                        <ng-container *ngSwitchCase="'CHILDREN'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <button
                                        mat-icon-button
                                        aria-label="expand row"
                                        (click)="
                                        expandedElement = expandedElement === element?.recordId ? null : element?.recordId;
                                        onExpandRow.emit(element);
                                        $event.stopPropagation()
                                    "
                                        *ngIf="element?.children">
                                    <mat-icon *ngIf="expandedElement !== element?.recordId">add_circle_outline</mat-icon>
                                    <mat-icon *ngIf="expandedElement === element?.recordId">remove_circle_outline</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'TEMPLATE'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                <div class="d-flex">
                                    <ng-container *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                    <ng-container *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <ng-container
                                              *ngTemplateOutlet="
                                        templates[columnId];
                                        context: { element: element, columnId: columnId }
                                    "></ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'ACCORDIAN'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <div class="d-flex" *ngIf="element['accordian'] === false && element['fileName']">
                                    <span
                                          class="accordian_body_text"
                                          (click)="downloadUplodedFile(element, element[columnId])"
                                          [title]="element[columnId] || '--'"
                                          [textContent]="element[columnId]"></span>
                                </div>
                                <div class="d-flex" *ngIf="element['downloadable'] === true">
                                    <span
                                          class="accordian_body_text"
                                          (click)="downloadUplodedFile(element, element[columnId])"
                                          [title]="element[columnId] || '--'"
                                          [textContent]="element[columnId]"></span>
                                </div>
                                <div class="d-flex" *ngIf="element['downloadable'] === false">
                                    <span [title]="element[columnId] || '--'" [textContent]="element[columnId]"></span>
                                </div>
                                <div class="d-flex" *ngIf="element['accordian'] === 'noData'">
                                    <span [title]="element[columnId] || '--'" [textContent]="element[columnId]"></span>
                                </div>
                                <mat-accordion class="tableColumnAccordian" *ngIf="element['accordian'] === true">
                                    <mat-expansion-panel hideToggle #source>
                                        <mat-expansion-panel-header>
                                            <div class="col-9 p-0">
                                                <mat-panel-title>
                                                    <span
                                                          class="accordian_body_text"
                                                          stop-propagation
                                                          (click)="downloadUplodedFile(element, element[columnId][0])"
                                                          [textContent]="element[columnId][0]"></span>
                                                </mat-panel-title>
                                            </div>
                                            <mat-icon class="title_icon" *ngIf="!source.expanded">add_circle_outline</mat-icon>
                                            <mat-icon class="title_icon" *ngIf="source.expanded">remove_circle_outline</mat-icon>
                                        </mat-expansion-panel-header>
                                        <div class="d-flex accordian_body" *ngFor="let accordian of element[columnId] | slice : 1">
                                            <span
                                                  class="accordian_body_text"
                                                  (click)="downloadUplodedFile(element, accordian)"
                                                  [textContent]="accordian"></span>
                                        </div>
                                    </mat-expansion-panel>
                                </mat-accordion>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'file'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                <material-checkbox
                                                   class="columnToUpdate"
                                                   [(model)]="columnsToUpdate[columnId]"
                                                   [class.displayNone]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"></material-checkbox>
                                <material-button
                                                 buttonType="icon"
                                                 [size]="'small'"
                                                 prefixIcon="edit"
                                                 [classList]="['fontSizeCls']"
                                                 [hidden]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"
                                                 (buttonClicked)="editColumnEvent.emit(columnId)"></material-button>
                                <div class="d-flex">
                                    <ng-container *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                    <ng-container *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell file-browse" stop-propagation>
                                <span class="tableFilesUploadContainer">
                                    <app-file-upload
                                                     [data]="attachmentData"
                                                     [clearFiles]="clearFiles"
                                                     (newValue)="fileChanged($event, element)"
                                                     [appendedFileName]="element.fileName"
                                                     (fileName)="changedFileName($event, element)"></app-file-upload>
                                </span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'link'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                <material-checkbox
                                                   class="columnToUpdate"
                                                   [(model)]="columnsToUpdate[columnId]"
                                                   [class.displayNone]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"></material-checkbox>
                                <material-button
                                                 buttonType="icon"
                                                 [size]="'small'"
                                                 prefixIcon="edit"
                                                 [classList]="['fontSizeCls']"
                                                 [hidden]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"
                                                 (buttonClicked)="editColumnEvent.emit(columnId)"></material-button>
                                <div class="d-flex">
                                    <ng-container *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                    <ng-container *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell" stop-propagation>
                                <ng-container
                                              [ngSwitch]="
                                        element[columnId] &&
                                        (element[columnId].indexOf('http://') > -1 || element[columnId].indexOf('https://') > -1)
                                    ">
                                    <ng-container *ngSwitchCase="true">
                                        <span class="downloadLink">
                                            <a
                                               [href]="element[columnId]"
                                               target="_blank"
                                               rel="noopener"
                                               [textContent]="translate('Download')"></a>
                                        </span>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <span
                                              class="downloadLink"
                                              (click)="downloadSourceTemplateUrl(element)"
                                              [textContent]="translate('Download')"></span>
                                    </ng-container>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="'PASSWORD'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <material-button
                                                 *ngIf="columnKeyPair?.[columnId]?.icon"
                                                 buttonType="icon"
                                                 [size]="'small'"
                                                 [prefixIcon]="columnKeyPair?.[columnId]?.icon"
                                                 [classList]="['title_icon', columnKeyPair?.[columnId]?.icon]"></material-button>
                                <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                <material-checkbox
                                                   class="columnToUpdate"
                                                   [(model)]="columnsToUpdate[columnId]"
                                                   [class.displayNone]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"></material-checkbox>
                                <material-button
                                                 buttonType="icon"
                                                 [size]="'small'"
                                                 prefixIcon="edit"
                                                 [classList]="['fontSizeCls']"
                                                 [hidden]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"
                                                 (buttonClicked)="editColumnEvent.emit(columnId)"></material-button>
                                <div class="d-flex">
                                    <ng-container *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                    <ng-container *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <span *ngIf="element[columnId]">*****</span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <ng-container [ngSwitch]="columnTypePair[columnId]">
                                <ng-container *ngSwitchCase="'ALL_COLUMNS_LIST'">
                                    <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader logMenuIcon">
                                        <div class="logMenuActions">
                                            <span class="material-icons logIcon" [matMenuTriggerFor]="logMenu">menu</span>
                                            <span
                                                  *ngIf="clearSearchedFilter"
                                                  class="text-[#ff000080] cursor-pointer !relative !top-[10px]"
                                                  (click)="clearFilter.emit()"
                                                  [title]="translate('Clear Filters')"
                                                  [textContent]="translate('Clear')"></span>
                                        </div>
                                        <mat-menu #logMenu="matMenu" [class]="'tableLogMenu !bg-white'" xPosition="after" yPosition="below">
                                            <div class="logMenu" stop-propagation cdkDropList (cdkDropListDropped)="dropColumnMenu($event)">
                                                <div class="logFilter" stop-propagation>
                                                    <mat-form-field>
                                                        <input
                                                               matInput
                                                               class="filterInput"
                                                               autocomplete="off"
                                                               [placeholder]="translate('Filter Table Columns')"
                                                               [(ngModel)]="searchColumns" />
                                                        <material-button
                                                                         *ngIf="searchColumns"
                                                                         matSuffix
                                                                         buttonType="icon"
                                                                         size="small"
                                                                         color="default"
                                                                         (buttonClicked)="searchColumns = ''"
                                                                         prefixIcon="close"
                                                                         prefixIconType="material"></material-button>
                                                    </mat-form-field>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex justify-content-around align-items-center" stop-propagation>
                                                        <material-checkbox
                                                                           [(model)]="selectAll"
                                                                           (modelChange)="selectAllFilters($event)"
                                                                           [name]="'Select All'"
                                                                           [title]="'Select All'"
                                                                           [showName]="true"
                                                                           id="selectAllLabel"
                                                                           [disabled]="false"></material-checkbox>
                                                    </div>
                                                    <material-button
                                                                     [color]="'primary'"
                                                                     [disabled]="clonedColumns?.length === 0"
                                                                     [text]="translate('Apply')"
                                                                     (buttonClicked)="cloneSubmit()"></material-button>
                                                </div>
                                                <div
                                                     class="logListItems mb-2"
                                                     *ngFor="
                                                        let column of allColumns | FilterPipe : 'name' : searchColumns;
                                                        let i = index;
                                                        trackBy: trackByAllColumnsMethod
                                                    "
                                                     stop-propagation
                                                     cdkDrag
                                                     [cdkDragDisabled]="
                                                        !enableColumnsConfig || !!searchColumns || clonedColumns?.indexOf(column.id) === -1
                                                    ">
                                                    <div
                                                         class="d-flex align-items-center tempList gap-2"
                                                         [hidden]="
                                                            !(
                                                                (!searchColumns ||
                                                                    searchColumns.length === 0 ||
                                                                    (searchColumns.length > 0 &&
                                                                        column.name.toLowerCase().indexOf(searchColumns.toLowerCase()) >
                                                                            -1)) &&
                                                                actionColumns.indexOf(column.id) === -1 &&
                                                                !(hideTableColumns && hideTableColumns.indexOf(column.id) > -1) &&
                                                                !column.hideInAllColumnsList
                                                            )
                                                        ">
                                                        <mat-icon
                                                                  *ngIf="enableColumnsConfig"
                                                                  cdkDragHandle
                                                                  class="cursor-move !text-[18px] !text-[#888] !w-[25px] !h-[18px] d-flex align-items-center justify-content-left"
                                                                  [style.visibility]="
                                                                clonedColumns?.indexOf(column.id) > -1 ? 'visible' : 'hidden'
                                                            ">
                                                            drag_indicator
                                                        </mat-icon>
                                                        <div class="mCheckbox">
                                                            <material-checkbox
                                                                               [hidden]="
                                                                    column.type === 'SELECTRECORD' || column.name === 'dynamicActions'
                                                                "
                                                                               [model]="clonedColumns?.indexOf(column.id) > -1"
                                                                               (modelChange)="checkboxSelect($event, column)"
                                                                               [name]="column.name"
                                                                               [showName]="true"></material-checkbox>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </mat-menu>
                                        <ng-container *ngIf="columnSearchRequired && !clearSearchedFilter">
                                            <div class="searchHiddenDiv"></div>
                                        </ng-container>
                                        <div class="d-flex">
                                            <ng-container
                                                          *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                            <ng-container
                                                          *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="matTableCell"></td>
                                </ng-container>
                                <ng-container *ngSwitchCase="'ACTIONS'">
                                    <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader alignCenter">
                                        <div>
                                            <span [textContent]="customActionHeaderName || translate('Actions')"></span>
                                        </div>
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="matTableCell alignCenter">
                                        <div class="actionsMenu tableActionsMenu">
                                            <ng-container *ngFor="let action of recordActions; trackBy: trackByActionsMethod">
                                                <span [hidden]="!actionVisibility[element.recordId][action.displayName]">
                                                    <ng-container
                                                                  *ngIf="
                                                            (!action.isToggle && !action.conditionalDisplay) ||
                                                            (action.byFieldValue &&
                                                                ((action.conditionType === 'NOT_EQUALS' &&
                                                                    element[action.conditionalFieldId] !== action.conditionalFieldValue) ||
                                                                    (action.conditionType === 'EQUALS' &&
                                                                        element[action.conditionalFieldId] ===
                                                                            action.conditionalFieldValue) ||
                                                                    (action.conditionType === 'EXISTS' &&
                                                                        element[action.conditionalFieldId] !== undefined)))
                                                        ">
                                                        <material-button
                                                                         buttonType="icon"
                                                                         size="small"
                                                                         color="default"
                                                                         class="actionButtons"
                                                                         [titleText]="action.displayName"
                                                                         (buttonClicked)="
                                                                action.onActionTrigger && action.onActionTrigger(element, action)
                                                            "
                                                                         [prefixIcon]="action.iconName"
                                                                         prefixIconType="material"
                                                                         [classList]="
                                                                action.iconName === 'warning' ? ['displayActionColor'] : []
                                                            "></material-button>
                                                    </ng-container>
                                                    <ng-container
                                                                  *ngIf="
                                                            action.isToggle &&
                                                            (!action.conditionalDisplay ||
                                                                (action.byFieldValue &&
                                                                    ((action.conditionType === 'NOT_EQUALS' &&
                                                                        element[action.conditionalFieldId] !==
                                                                            action.conditionalFieldValue) ||
                                                                        (action.conditionType === 'EQUALS' &&
                                                                            element[action.conditionalFieldId] ===
                                                                                action.conditionalFieldValue) ||
                                                                        (action.conditionType === 'EXISTS' &&
                                                                            element[action.conditionalFieldId] !== undefined))))
                                                        ">
                                                        <mat-slide-toggle
                                                                          size="small"
                                                                          class="relative !right-5"
                                                                          [checked]="!element.disabled"
                                                                          (change)="
                                                                action.onActionTrigger && action.onActionTrigger(element, $event.checked)
                                                            "
                                                                          [matTooltip]="element.disabled ? 'Enable' : 'Disable'"
                                                                          color="primary"></mat-slide-toggle>
                                                    </ng-container>
                                                </span>
                                            </ng-container>
                                        </div>
                                        <ng-container *ngIf="!recordActions || recordActions.length === 0">
                                            <material-button
                                                             buttonType="flat"
                                                             size="small"
                                                             color="default"
                                                             [text]="translate('No Actions Found')"></material-button>
                                        </ng-container>
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                        <span [textContent]="columnKeyPair?.[columnId]?.name"></span>
                                        <material-checkbox
                                                           class="columnToUpdate"
                                                           [(model)]="columnsToUpdate[columnId]"
                                                           [class.displayNone]="
                                                !enableColumnEdit || fieldsDisabledForEdit.includes(columnId)
                                            "></material-checkbox>
                                        <material-button
                                                         buttonType="icon"
                                                         [size]="'small'"
                                                         prefixIcon="edit"
                                                         [classList]="['fontSizeCls']"
                                                         [hidden]="!enableColumnEdit || fieldsDisabledForEdit.includes(columnId)"
                                                         (buttonClicked)="editColumnEvent.emit(columnId)"></material-button>
                                        <div class="d-flex">
                                            <ng-container
                                                          *ngTemplateOutlet="searchInputTemplate; context: { column: columnId }"></ng-container>
                                            <ng-container
                                                          *ngTemplateOutlet="aggregationsTemplate; context: { column: columnId }"></ng-container>
                                        </div>
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let element"
                                        class="matTableCell"
                                        [title]="
                                            element.isDeleted
                                                ? 'This record was deleted'
                                                : element.inAudit && columnKeyPair?.[columnId]?.uiTypeMetadata == 'TEXTAREA'
                                                ? element[columnId] || '--'
                                                : ''
                                        ">
                                        <ng-container [ngSwitch]="element.inAudit">
                                            <ng-container *ngSwitchCase="true">
                                                <ng-container
                                                              *ngIf="
                                                        columnKeyPair?.[columnId]?.uiTypeMetadata === 'TEXTAREA' ||
                                                            element?.uiTypeMetadata === 'TEXTAREA';
                                                        else normalText
                                                    ">
                                                    <span
                                                          class="angular-editor-textarea plain-text oldAuditValue"
                                                          [title]="element?.[columnId + '_oldValue'] | decodeTextField:true | TruncateHTMLTags"
                                                          [innerHTML]="element?.[columnId + '_oldValue'] | decodeTextField"></span>
                                                    <span
                                                          class="angular-editor-textarea plain-text newAuditValue"
                                                          [title]="element?.[columnId + '_newValue'] | decodeTextField:true | TruncateHTMLTags"
                                                          [innerHTML]="element?.[columnId + '_newValue'] | decodeTextField"></span>
                                                </ng-container>
                                                <ng-template #normalText>
                                                    <span class="oldAuditValue">
                                                        <span [textContent]="'old: ' + element?.[columnId + '_oldValue']"></span>
                                                    </span>
                                                    <span class="newAuditValue">
                                                        <span [textContent]="'new: ' + element?.[columnId + '_newValue']"></span>
                                                    </span>
                                                </ng-template>
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <ng-container
                                                              *ngIf="
                                                        columnKeyPair?.[columnId]?.uiTypeMetadata === 'TEXTAREA' ||
                                                            element?.uiTypeMetadata !== 'TEXTAREA';
                                                        else normalText
                                                    ">
                                                    <span
                                                          class="angular-editor-textarea plain-text"
                                                          [title]="element[columnId] | decodeTextField : true | TruncateHTMLTags"
                                                          [innerHTML]="element[columnId] | decodeTextField"></span>
                                                </ng-container>
                                                <ng-template #normalText>
                                                    <span
                                                          [class.dataTypeTextAlign]="
                                                            ['INT', 'LONG', 'FLOAT', 'DOUBLE', 'DECIMAL'].includes(
                                                                columnKeyPair?.[columnId]?.inputType
                                                            )
                                                        ">
                                                        <span [textContent]="element[columnId]"></span>
                                                    </span>
                                                </ng-template>
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
                <td class="expandedTableRow" mat-cell *matCellDef="let element" [attr.colspan]="selectedColumns.length">
                    <div class="example-element-detail" [@detailExpand]="element?.recordId === expandedElement ? 'expanded' : 'collapsed'">
                        <ng-container *ngIf="expandedElement === element?.recordId">
                            <ng-container
                                          *ngTemplateOutlet="
                                    expandedElementTemplate;
                                    context: { recordId: element.id || element.recordId, record: element }
                                "></ng-container>
                        </ng-container>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="tableLoading">
                <td mat-footer-cell class="matTableMessages" *matFooterCellDef colspan="100%">
                    <div class="loaderBlock isLoading"></div>
                </td>
            </ng-container>
            <ng-container matColumnDef="noData">
                <td mat-footer-cell class="matTableMessages" *matFooterCellDef colspan="100%">
                    <span
                          [textContent]="
                            noRecordMsg && pagination?.value?.count > 0
                                ? translate('No records')
                                : noRecordMsg && !(pagination?.value?.count > 0)
                                ? noRecordMsg
                                : translate('No records found')
                        "></span>
                </td>
            </ng-container>
            <ng-container matColumnDef="noRecords">
                <td mat-footer-cell class="matTableMessages noRecordMessage" *matFooterCellDef colspan="100%">
                    <span [textContent]="translate('No records found')"></span>
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="selectedColumns; sticky: !noSticky"
                [ngClass]="{ tableHeaderPadding: columnSearchRequired }"></tr>
            <tr
                mat-row
                *matRowDef="let element; columns: selectedColumns"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element?.recordId"
                [class.isDeleted]="element.isDeleted"
                [class.disabled]="element.disabled"
                [class.matTableError]="element.errorsCount && element.errorsCount > 0"
                [class.matTableWarning]="element.warningsCount && element.warningsCount > 0"
                [ngClass]="{ 'hover:!border-[2px] hover:!border-solid hover:!border-[#7556c8] hover:!h-[50px]': showRowBorders }"
                (click)="onSingleClick(element)"
                (dblclick)="onDoubleClick(element)"
                [title]="
                    element.isDeleted ? 'This record was deleted' : element.tooltip && element.tooltip.length > 0 ? element.tooltip : ''
                "></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            <tr
                mat-footer-row
                *matFooterRowDef="['tableLoading']"
                [ngClass]="{ hide: dataSource !== null && !loading }"
                [class.loadingTable]="loading"></tr>
            <tr
                mat-footer-row
                *matFooterRowDef="['noData']"
                [ngClass]="{ hide: !(dataSource !== null && dataSource.data.length === 0 && !loading) }"></tr>
            <tr mat-footer-row *matFooterRowDef="['noRecords']" [ngClass]="{ hide: !noRecordsFound }"></tr>
        </table>
    </div>
    <ng-container
                  *ngIf="
            (dataSource?.data?.length > 0 || pageIndexSelected > 0 || pagination?.value?.pageIndex > 0 || alwaysShowPaginator) &&
            defaultPaginator
        ">
        <mat-paginator
                       [hidden]="dataSource?.data?.length === 0"
                       [pageSizeOptions]="customSizeOptions.length ? customSizeOptions : [5, 10, 20]"
                       [length]="dataSource?.data?.length"
                       [pageSize]="10"
                       showFirstLastButtons="true"></mat-paginator>
    </ng-container>
    <ng-container *ngIf="(dataSource?.data?.length > 0 || pageIndexSelected > 0 || pagination?.value?.pageIndex > 0) && newCustomPaginator">
        <div class="newCustomPagination">
            <ul class="newCustomPaginationUl">
                <li class="newCustomPaginationLi newCustomPaginationPageIndex">
                    <mat-form-field appRemoveAriaOwns>
                        <mat-label>Page Index</mat-label>
                        <mat-select [(value)]="pageIndexSelected" [disabled]="customPageIndex.length < 2">
                            <mat-option
                                        *ngFor="let index of customPageIndex"
                                        [value]="index"
                                        (click)="fetchItemsInPageWithPageIndex.emit(index)">
                                <span [textContent]="index"></span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </li>
                <li class="newCustomPaginationLi newCustomPaginationPageIndex">
                    <mat-form-field appRemoveAriaOwns>
                        <mat-label>Page Size</mat-label>
                        <mat-select [(value)]="sizeSelected">
                            <mat-option
                                        *ngFor="let size of customSize"
                                        [value]="size"
                                        (click)="refreshItemsWithNewPageSize.emit({ pageSize: size })">
                                <span [textContent]="size"></span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </li>
                <li class="newCustomPaginationLi newCustomPaginationArrows">
                    <mat-icon
                              class="leftArrow"
                              [ngClass]="{ disable: disablePrevious }"
                              title="previous"
                              (click)="fetchItemsInPage.emit('previous')">
                        chevron_left
                    </mat-icon>
                    <mat-icon class="rightArrow" title="next" [ngClass]="{ disable: disableNext }" (click)="fetchItemsInPage.emit('next')">
                        chevron_right
                    </mat-icon>
                </li>
            </ul>
        </div>
    </ng-container>
    <ng-container
                  *ngIf="
            (dataSource?.data?.length > 0 || pageIndexSelected > 0 || pagination?.value?.pageIndex > 0) &&
            pagination &&
            pagination.value &&
            pagination.value.count > 0
        ">
        <ng-container *ngIf="hidePaginator !== true && pagination">
            <material-paginator
                                [paginationSubject]="pagination"
                                [showCount]="showCount"
                                (fetchItemsInPage)="fetchItemsInPage.emit($event)"
                                (refreshItemsWithNewPageSize)="refreshItemsWithNewPageSize.emit({ pageSize: $event })"></material-paginator>
        </ng-container>
    </ng-container>
</div>

<ng-template #textTemplate let-element="element" let-columnId="columnId">
    <ng-container [ngSwitch]="element.inAudit">
        <ng-container *ngSwitchCase="true">
            <ng-container
                          *ngIf="columnKeyPair?.[columnId]?.uiTypeMetadata === 'TEXTAREA' || element?.uiTypeMetadata === 'TEXTAREA'; else normalText">
                <span
                      class="angular-editor-textarea plain-text oldAuditValue"
                      [title]="element?.[columnId + '_oldValue'] | decodeTextField:true | TruncateHTMLTags"
                      [innerHTML]="element?.[columnId + '_oldValue'] | decodeTextField"></span>
                <span
                      class="angular-editor-textarea plain-text newAuditValue"
                      [title]="element?.[columnId + '_newValue'] | decodeTextField:true | TruncateHTMLTags"
                      [innerHTML]="element?.[columnId + '_newValue'] | decodeTextField"></span>
            </ng-container>
            <ng-template #normalText>
                <span class="oldAuditValue" [textContent]="element?.[columnId + '_oldValue']"></span>
                <span class="newAuditValue" [textContent]="element?.[columnId + '_newValue']"></span>
            </ng-template>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <ng-container
                          *ngIf="columnKeyPair?.[columnId]?.uiTypeMetadata === 'TEXTAREA' || element?.uiTypeMetadata === 'TEXTAREA'; else normalText">
                <span
                      class="angular-editor-textarea plain-text"
                      [title]="element[columnId] | decodeTextField : true | TruncateHTMLTags"
                      [innerHTML]="element[columnId] | decodeTextField"></span>
            </ng-container>
            <ng-template #normalText>
                <span
                      [class.dataTypeTextAlign]="['INT', 'LONG', 'FLOAT', 'DOUBLE', 'DECIMAL'].includes(columnKeyPair?.[columnId]?.inputType)"
                      [title]="element[columnId] | decodeTextField : true | TruncateHTMLTags"
                      [innerHTML]="element[columnId] | decodeTextField"></span>
            </ng-template>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #gridTemplate let-element="element" let-columnId="columnId" let-column="column" let-showGridIcon="showGridIcon">
    <material-button
                     buttonType="icon"
                     prefixIcon="grid_on"
                     prefixIconType="material"
                     color="default"
                     size="small"
                     class="actionButtons"
                     (buttonClicked)="clickedCell(column, $event, element)"
                     [hidden]="showGridIcon !== undefined ? !showGridIcon : false"></material-button>
</ng-template>

<ng-template
             #menuTemplate
             let-element="element"
             let-columnId="columnId"
             let-options="options"
             let-colorCodes="colorCodes"
             let-column="column">
    <ng-container *ngIf="!recordFieldsDisabledForEdit?.[element.recordId]?.includes(columnId)">
        <material-menu-button
                              [buttonType]="'flat'"
                              [hideRipple]="true"
                              [style.color]="colorCodes?.[element[columnId]] || ''"
                              [text]="element[columnId]"
                              [suffixIconType]="'material'"
                              [labelClassList]="['!p-0 !gap-0']"
                              [textClassList]="['max-w-[120px] overflow-x-hidden text-ellipsis']"
                              [suffixIconClassList]="['!text-[24px]']"
                              [suffixIcon]="'arrow_drop_down'"
                              [menuClassList]="'!min-h-[45px]'">
            <div *ngFor="let opt of options">
                <button
                        mat-menu-item
                        class="hover:!bg-[#0000000a]"
                        [style.color]="colorCodes?.[opt?.name || opt] || ''"
                        (click)="onOptionSelect(column, opt?.name || opt, element?.recordId)"
                        [textContent]="opt?.name || opt"></button>
            </div>
        </material-menu-button>
    </ng-container>
    <ng-container *ngIf="recordFieldsDisabledForEdit?.[element.recordId]?.includes(columnId)">
        <span class="text-[#00a651]" [textContent]="element[columnId]"></span>
    </ng-container>
</ng-template>
